import { createTheme } from '@mui/material';
import { colors } from '../constants';

export const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: 'Orgon, sans-serif',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                fullWidth: true,
            },
            styleOverrides: {
                root: {
                    marginBottom: '15px',
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    padding: '4px',
                    '&&.Mui-error': {
                        color: colors.error,
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.white,
                    fontFamily: 'Orgon',
                    color: colors.black,
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: colors.greyMedium,
                    '&&.Mui-focused': {
                        color: colors.black,
                    },
                    '&&.Mui-error': {
                        color: colors.error,
                    },
                    fontFamily: 'Orgon',
                    lineHeight: '1.7',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '.MuiOutlinedInput-notchedOutline': {
                        transition: 'border-color 0.25s linear',
                        borderColor: colors.white,
                    },
                    '&&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.grey,
                    },
                    '&&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.greyMedium,
                        borderWidth: '1.5px',
                    },
                    '&&.Mui-error .MuiOutlinedInput-notchedOutline ': {
                        borderColor: colors.error,
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    alignItems: 'flex-start',
                    margin: 0,
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    padding: '0 20px 0 0',
                    color: colors.black,
                    '&&.Mui-checked': {
                        color: colors.black,
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: colors.black,
                    padding: '10px',
                    fontSize: '14px',
                    fontFamily: 'Orgon',
                    lineHeight: '1.7',
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                listbox: {
                    maxHeight: '250px',
                },
            },
        },
    },
});
